<template>
    <div v-if="isRootNode">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_stt_extension_setting'"></div>
        </div>
        <div class="object-inner-table">
            <table width=100%>
                <tr width="100%" class="no-data-message">
                    <td style="display: inline-block" v-html="$t('message.hint_menu_stt_dictionary')">
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div v-else>
        <div v-if="!showOptionSetting">
            <div class="object-titlebox">
                <div class="object-titlebox-left" v-t="'message.item_stt_extension_setting'"></div>
            </div>
            <div class="object-inner-table">
                <table width=100%>
                    <td style="width:50%" class="object-item" v-t="'message.info_need_purchase_enterprise_plan'"></td>
                </table>
            </div>
        </div>
        <div v-else>
            <div class="object-titlebox">
                <div class="title-box-left">
                    <span v-t="'message.title_stt_extension_dictionary'" />
                    <el-tooltip effect="dark" placement="top-start">
                        <div slot="content" style="text-align:left"
                            v-html="$t('message.hint_stt_extension_dictionary')"></div>
                        <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt="" />
                    </el-tooltip>
                    <div class="title-box-right">
                        <button class="transparent" type="button" v-on:click="addDictionary()"><img
                                src="@/assets/add_user.svg" alt="" /><span class="normal-command-text"
                                v-t="'message.common_action_add'"></span></button>
                    </div>
                </div>
            </div>
            <table width="100%">
                <tr class="dict-title">
                    <td class="object-item1" style="width:60%"
                        v-t="'message.item_stt_extension_dictionary_display_name'"></td>
                    <td class="object-item2">
                        {{ $t('message.action_edit_stt_dictionary_auth_user') }}
                        <el-tooltip effect="dark" placement="top-start">
                            <div slot="content" style="text-align:left"
                                v-html="$t('message.hint_edit_stt_dictionary_auth_user')"></div>
                            <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt="" />
                        </el-tooltip>
                    </td>
                    <td class="object-item3" v-t="'message.item_group'"></td>
                    <td class="object-item3" v-t="'message.item_bot'" v-if="buddyBotApiLicensed"></td>
                    <td class="object-item3" v-t="'message.common_action_edit'"></td>
                    <td class="object-item3" v-t="'message.action_csv'"></td>
                    <td class="object-item3" v-t="'message.common_action_delete'"></td>
                </tr>
                <tr class="dict-record" v-for="dictionary in dictionaryInfoList">
                    <td class="object-item1" style="width:60%">
                        {{ dictionary.name }}
                    </td>
                    <td class="object-item2">
                        <button class="transparent" type="button" v-on:click="editAuthUser(dictionary)"><img
                                src="@/assets/icon_stt_dictionary_add_auth_user.svg" alt="" /></button>
                    </td>
                    <td class="object-item3">
                        <button class="transparent" type="button" v-on:click="assignDictionary(dictionary)"><span
                                class="normal-command-text" v-t="'message.action_assign'"></span></button>
                    </td>
                    <td class="object-item3" v-if="buddyBotApiLicensed">
                        <button class="transparent" type="button" v-on:click="assignDictionaryToBot(dictionary)"><span class="normal-command-text" v-t="'message.action_assign'"></span></button>
                    </td>
                    <td class="object-item3">
                        <button class="transparent" type="button" v-on:click="editDictionary(dictionary)"><img
                                src="@/assets/edit.svg" alt="" /></button>
                    </td>
                    <td class="object-item3">
                        <button class="transparent" type="button" v-on:click="csvDictionary(dictionary)"><img
                                src="@/assets/icon_csv.svg" alt="" /></button>
                    </td>
                    <td class="object-item3">
                        <button class="transparent" type="button" v-on:click="deleteDictionary(dictionary)"><img
                                src="@/assets/icon_delete_user.svg" alt="" /></button>
                    </td>
                </tr>
            </table>
            <editAuthUser v-if="showDictionaryDialog.editAuth" ref="editAuthUser" :appData="$root.store.appData"
                :authUsers="authUserListForUserSelection()" @save="doEditAuthUser"
                @cancel="showDictionaryDialog.editAuth = false"></editAuthUser>
            <addDictionary v-if="showDictionaryDialog.add" ref="AddSttDictionary"
                @validateDictNameDuplicated="validateDictNameDuplicated" @save="doAddDictionary"
                @cancel="showDictionaryDialog.add = false"></addDictionary>
            <assignDictionary v-if="showDictionaryDialog.assign" ref="AssignDictionary" :tenantId="$root.store.tenantId"
                :baseDictionaryInfo="selectedDictionaryInfo" @save="doAssignDictionary"
                @cancel="showDictionaryDialog.assign = false"></assignDictionary>
            <assignDictionaryToBot v-if="showDictionaryDialog.assignBot" ref="AssignBotDictionary" :tenantId="$root.store.tenantId"
                :baseDictionaryInfo="selectedDictionaryInfo" @save="doAssignDictionary"
                @cancel="showDictionaryDialog.assignBot = false"></assignDictionaryToBot>
            <editDictionary v-if="showDictionaryDialog.edit" ref="EditDictionary"
                @validateDictNameDuplicated="validateDictNameDuplicated" :baseDictionaryInfo="selectedDictionaryInfo"
                @save="doEditDictionary" @cancel="showDictionaryDialog.edit = false"></editDictionary>
            <csvDictionary v-if="showDictionaryDialog.csv" ref="CsvDictionary"
                :selectedDictionaryInfo="selectedDictionaryInfo" @cancel="showDictionaryDialog.csv = false">
            </csvDictionary>
            <deleteDictionary v-if="showDictionaryDialog.delete" ref="DeleteDictionary" :confirmInfo="confirmInfo"
                @delete="doDeleteDictionary" @cancel="showDictionaryDialog.delete = false"></deleteDictionary>
        </div>
    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import SttDictionaryAssignToAuthUser from "@/components/pc/setting/sttextention/SttDictionaryAssignToAuthUser";
import SttDictionaryAdd from "@/components/pc/setting/sttextention/SttDictionaryAdd";
import SttDictionaryAssignToTalkGroup from "@/components/pc/setting/sttextention/SttDictionaryAssignToTalkGroup";
import SttDictionaryAssignToBot from "@/components/pc/setting/sttextention/SttDictionaryAssignToBot";
import SttDictionaryEdit from "@/components/pc/setting/sttextention/SttDictionaryEdit";
import SttDictionaryCsv from "@/components/pc/setting/sttextention/SttDictionaryCsv";
import DeleteObject from "../../../DeleteObject.vue";

export default {
    components: {
        editAuthUser: SttDictionaryAssignToAuthUser,
        addDictionary: SttDictionaryAdd,
        assignDictionary: SttDictionaryAssignToTalkGroup,
        assignDictionaryToBot: SttDictionaryAssignToBot,
        editDictionary: SttDictionaryEdit,
        csvDictionary: SttDictionaryCsv,
        deleteDictionary: DeleteObject,
    },

    props: {
        selectedNode: {},
    },

    data() {
        return {
            showDictionaryDialog: {
                editAuth: false,
                add: false,
                assign: false,
                assignBot: false,
                edit: false,
                csv: false,
                delete: false,
            },
            maxDictionaryCount: 0,
            dictionaryInfoList: [],
            selectedDictionaryInfo: null,
            authUserList: [],
            confirmInfo: {
                objectName: null,
                objectTitle: null,
            },
            buddyBotApiLicensed: false,
        }
    },

    computed: {
        showOptionSetting: function() {
            return this.$root.store.appData.enableSpeechTextOption || this.$root.store.appData.enableSpeechTextTrial;
        },
        isRootNode () {
            return this.selectedNode.data.type === constants.SETTING_STT_EXTENSION_ROOT;
        },
    },

    created: function() {
        if (this.showOptionSetting) {
            this.getDictionaryInfo();
        }

        this.buddyBotApiLicensed = this.$root.store.appData.enableBuddyBotApi || this.$root.store.appData.enableBuddyBotApiTrial;
    },

    methods: {
        getDictionaryInfo: function () {
            let self = this;
            server.post('/getsttdictionaryinfo', {})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.dictionaryInfoList = res.data.dictionaryInfoList;
                            self.maxDictionaryCount = res.data.maxDictionaryCount;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getDictionaryInfo").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self, "getDictionaryInfo", error);
                });
        },

        editAuthUser(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.showDialogAfterWritableCheck("editAuth");
        },

        addDictionary() {
            if (this.dictionaryInfoList.length >= this.maxDictionaryCount) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_stt_extension_dictionary_exceeds_max_count").replace("{maxDictionaryCount}",this.maxDictionaryCount));
                return;
            }
            this.showDialogAfterWritableCheck("add");
        },

        assignDictionary(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.showDialogAfterWritableCheck("assign");
        },

        assignDictionaryToBot(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.showDialogAfterWritableCheck("assignBot");
        },

        editDictionary(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.showDialogAfterWritableCheck("edit");
        },

        csvDictionary(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.showDialogAfterWritableCheck("csv");
        },

        deleteDictionary(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "title_stt_extension_dictionary");
            this.confirmInfo.objectName = this.selectedDictionaryInfo.name;
            this.showDialogAfterWritableCheck("delete");
        },

        doEditAuthUser(input) {
            let addUserIdList = [];
            let deleteUserIdList = [];

            if (input.addTagList) {
                for (let key in input.addTagList) {
                    addUserIdList.push(input.addTagList[key].userId);
                }
            }

            if (input.removeTagList) {
                for (let key in input.removeTagList) {
                    deleteUserIdList.push(input.removeTagList[key].userId);
                }
            }

            if (addUserIdList.length === 0 && deleteUserIdList.length === 0) {
                commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n, "info_no_changing_information"));
                this.showDictionaryDialog.editAuth = false;
                return;
            }

            let totalAuthUserCount = this.authUserList.length + addUserIdList.length - deleteUserIdList.length;
            if (totalAuthUserCount > constants.STT_DICTIONARY_MAX_AUTH_USER_LIMIT) {
                commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_dictionary_max_auth_user_count").replace("{limit}", constants.STT_DICTIONARY_MAX_AUTH_USER_LIMIT));
                return;
            }

            let self = this;
            server.post('/modifysttdictionaryassignauthuser', { dictionaryId: this.selectedDictionaryInfo.id, addUserIdList: addUserIdList, deleteUserIdList: deleteUserIdList })
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_assign_stt_dictionary_auth_user"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_stt_extension_dictionary_already_changed"));
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "doEditAuthUser").replace("{code}", res.data.status));
                            break;
                    }
                    self.showDictionaryDialog.editAuth = false;
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "doEditAuthUser", error);
                    self.showDictionaryDialog.editAuth = false;
                });
        },

        authUserListForUserSelection() {
            return this.authUserList.map(user => {
                return {
                    tenantId: this.tenantId,
                    id: user.userId,
                    name: user.userName,
                    displayName: user.displayName,
                }
            });
        },

        async getSttDictionaryAuthUsers() {
            try {
                const res = await server.post('/getsttdictionaryassignedauthuser', { dictionaryId: this.selectedDictionaryInfo.id })
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        res.data.users.sort((u1, u2) => {
                            return commonUtil.compareStringWithNumber(u1.userName, u2.userName);
                        });
                        this.authUserList = res.data.users;
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getSttDictionaryAuthUsers").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getSttDictionaryAuthUsers", e);
            }
        },

        doAddDictionary(dictionaryName) {
            let self = this;
            server.post('/createsttdictionary', {dictionaryName: dictionaryName})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getDictionaryInfo();
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_stt_extension_dictionary_added"));
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_invalid_params"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_name_already_exist"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_exceeds_max_count").replace("{maxDictionaryCount}",res.data.maxDictionaryCount));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doAddDictionary").replace("{code}",res.data.status));
                            break;
                    }
                    self.showDictionaryDialog.add = false;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "doAddDictionary", error);
                    self.showDictionaryDialog.add = false;
                });
        },

        doAssignDictionary(input, objectType) {
            let commandShowDialog =
                objectType === constants.OBJECT_TALKGROUP ? "assign" :
                objectType === constants.OBJECT_ASSISTANT ? "assignBot" : "";

            let operations = [];

            for (let key in input.addTagList) {
                let tag = input.addTagList[key];
                operations.push({
                    operation: 1, // add operation
                    objectType: objectType,
                    objectId: tag.objectId,
                });
            }

            for (let key in input.removeTagList) {
                let tag = input.removeTagList[key];
                operations.push({
                    operation: -1, // remove operation
                    objectType: objectType,
                    objectId: tag.objectId,
                });
            }

            if (operations.length === 0) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                this.showDictionaryDialog[commandShowDialog] = false;
                return;
            }

            let self = this;
            let loadingScreen = this.loadingScreenWith('processing ...');
            server.post('/modifysttdictionaryassignment', {dictionaryId: this.selectedDictionaryInfo.id, operationDataList: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_assign_stt_extension_dictionary"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doAssignDictionary").replace("{code}",res.data.status));
                            break;
                    }
                    self.showDictionaryDialog[commandShowDialog] = false;
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self,"doAssignDictionary",error);
                })
                .finally(() => {
                    loadingScreen.close();
                    self.showDictionaryDialog[commandShowDialog] = false;
                });
        },

        doEditDictionary(dictParams, phraseParams) {
            let dictChanged = dictParams.name !== this.selectedDictionaryInfo.name;
            let phraseChanged = phraseParams.inputList.length !== 0;

            if (!dictChanged && !phraseChanged) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                this.showDictionaryDialog.edit = false;
                return;
            }

            let self = this;
            let loadingScreen = this.loadingScreenWith('processing ...');

            let discountAndTasks = function() {
                let count = dictChanged + phraseChanged;
                return () => {
                    if (--count <= 0) {
                        loadingScreen.close();
                        self.showDictionaryDialog.edit = false;
                    }
                }
            }();

            // modify dictionary name
            if (dictChanged) {
                server.post('/renamesttdictionary', dictParams)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                self.getDictionaryInfo();
                                commonUtil.notifyMessage(self,'Success',commonUtil.getMessageText(self.$i18n, "info_modified_stt_extension_dictionary_name"));
                                break;
                            case constants.STATUS_ERROR_INVALID_PARAMETER:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_invalid_params"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                                break;
                            case constants.STATUS_ERROR_ALREADY_EXISTED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_name_already_exist"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doEditDictionary").replace("{code}",res.data.status));
                                break;
                        }
                    })
                    .catch(function(error) {
                        commonUtil.putExceptionErrorMessage(self,"doEditDictionary",error);
                    })
                    .finally(() => {
                        discountAndTasks();
                    });
            }

            // modify phrases
            if (phraseChanged) {
                server.post('/modifysttdictionaryphrase', phraseParams)
                    .then((res) => {
                        switch(res.data.status) {
                            case constants.STATUS_SUCCESS:
                                commonUtil.notifyMessage(self,'Success',commonUtil.getMessageText(self.$i18n,"info_modified_stt_extension_dictionary_phrase"));
                                break;
                            case constants.STATUS_ERROR_INVALID_PARAMETER:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_invalid_params"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                                break;
                            case constants.STATUS_ERROR_DUPLICATED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_phrase_duplicated"));
                                break;
                            case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_phrase_exceeds_max_count").replace("{maxPhraseCountPerLang}",res.data.maxPhraseCountPerLang));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doEditDictionary").replace("{code}",res.data.status));
                                break;
                        }
                    })
                    .catch(function(error) {
                        commonUtil.putExceptionErrorMessage(self,"doEditDictionary",error);
                    })
                    .finally(() => {
                        discountAndTasks();
                    });
            }
        },

        doDeleteDictionary() {
            let self = this;
            server.post('/deletesttdictionary', {dictionaryId: this.selectedDictionaryInfo.id})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getDictionaryInfo();
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_deleted_stt_extension_dictionary"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                            break;
                        case constants.STATUS_ERROR_STILL_ASSIGNED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_cannot_delete_still_asigined_dictionary"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName","doDeleteDictionary").replace("{code}",res.data.status));
                            break;
                    }
                    self.showDictionaryDialog.delete = false;
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self,"doDeleteDictionary",error);
                    self.showDictionaryDialog.delete = false;
                });
        },

        showDialogAfterWritableCheck(command) {
            if (this.$root.store.appData.tenantAdminUser) {
                this.showDialogAfterWritableCheckForTenantAdmin(command);
            } else {
                this.showDialogAfterWritableCheckForNotTenantAdmin(command);
            }
        },

        async showDialogAfterWritableCheckForTenantAdmin(command) {
            switch(command) {
                case "editAuth":
                    await this.getSttDictionaryAuthUsers();
                    break;
                case "edit":
                case "csv":
                case "add":
                case "assign":
                case "assignBot":
                case "delete":
                    break;
                default:
                    commonUtil.putExceptionErrorMessage(this, "showDialogAfterWritableCheckForTenantAdmin", error);
                    return;
            }
            this.showDictionaryDialog[command] = true;
        },

        async showDialogAfterWritableCheckForNotTenantAdmin(command) {
            switch(command) {
                case "edit":
                case "csv":
                    break;
                case "editAuth":
                case "add":
                case "assign":
                case "assignBot":
                case "delete":
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                    return;
                default:
                    commonUtil.putExceptionErrorMessage(this, "showDialogAfterWritableCheckForNotTenantAdmin", error);
                    return;
            }
            try {
                const res = await server.post('/checksttdictionaryauthuser', {
                    dictionaryId: this.selectedDictionaryInfo.id
                });
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.showDictionaryDialog[command] = true;
                        return;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_need_tenant_admin_and_stt_dictionary_auth_user_privilege"));
                        return;
                    default:
                        commonUtil.notifyMessage(this, "Error",commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "showDialogAfterWritableCheck").replace("{code}", res.data.status));
                        return;
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "showDialogAfterWritableCheckForNotTenantAdmin", error);
            }
        },

        validateDictNameDuplicated(name, callback){
            for (let dict of this.dictionaryInfoList) {
                if (dict.name === name) {
                    callback(false, commonUtil.getMessageText(this.$i18n,"error_stt_extension_dictionary_name_already_exist"))
                    return
                }
            }
            callback(true, null)
        },

        loadingScreenWith(text) {
            return this.$loading({
                    lock: true ,
                    text: text,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });
        },
    }
}


</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.icon-help {
    height: 14px;
}
.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}
.title-box-left {
    padding: 10px 10px 10px 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.object-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 12px;
}
.object-item2 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 28px;
    font-size: 12px;
    width: 10%;
    text-align: center;
}
.object-item3 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 28px;
    font-size: 12px;
    width: 6%;
    text-align: right;
}
.dict-title {
    background-color: #f6f6f6;
    color: #848991;
}
.dict-record {
    background-color:transparent;
    border-bottom: solid 1px #eee;
}
button.transparent img {
    display: inline;
    vertical-align: middle;
    height: 18px;
}

</style>
